<template>
  <div>
    <b-modal @cancel="hideModal" no-close-on-backdrop ref="ModalSales" size="xl" title="Sales" centered hide-footer
      scrollable>
      <template #modal-title>
        <b-row>
          <b-col cols="6">
            <h5>Sales</h5>
          </b-col>
        </b-row>
      </template>

      <b-row v-if="loading || loading" class="d-flex justify-content-center">
        <b-spinner style="width: 3rem; height: 3rem" variant="primary" label="Spinning"></b-spinner>
      </b-row>
      <b-row v-if="customer_cash_pending_sales.data && customer_cash_pending_sales.data.length == 0 && !loading"
        class="pl-3 pr-3 text-center">
        <b-col>
          <b-alert show variant="warning">No Sales Found</b-alert>
        </b-col>
      </b-row>

      <b-row style="margin-bottom:10px">
        <b-col cols="4" class="text-center"> </b-col>
        <b-col cols="4" class="text-left"> </b-col>
        <b-col cols="4" class="float-end text-right">
          <span style="font-size: 14px; color: red;">Due Amount
            {{
                cashAmount(
                  customer_cash_pending_sales.total_amount -
                  customer_cash_pending_sales.paid_amount
                )
            }}</span>
        </b-col>
      </b-row>

      <b-row v-if="customer_cash_pending_sales.data.length != 0 && !loading">
        <b-col cols="12" class="text-center">
          <table class="table table-hover table-striped">
            <tbody>
              <tr>
                <th class="text-center">Reference Number</th>
                <th class="text-center">Date</th>
                <th class="text-center">Amount</th>
                <th class="text-center">PaidAmount</th>
                <th class="text-center">Biller</th>
                <th class="text-center">Shop</th>
              </tr>
              <tr v-for="(item, index) in customer_cash_pending_sales.data" :key="index"
                style="border-bottom: 1px solid #c1c1c1">
                <td class="text-center">
                  {{ item.reference_number ? item.reference_number : '-' }}
                </td>
                <td class="text-center">
                  {{ moment(item.date) }}
                </td>
                <td class="text-center">{{ item.grand_total }}</td>
                <td class="text-center">{{ item.paid_amount }}</td>
                <td class="text-center">{{ item.biller.first_name }}</td>
                <td class="text-center">{{ item.shop.name }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'Sales',
  methods: {
    cashAmount(value) {

      return parseInt(value);
    },
    moment: function (date) {
      return moment(date).format('LL');
    },

    showModal() {
      this.loading = true;
      this.$refs['ModalSales'].show();
      this.loading = false;
    },
    hideModal() {
      this.$refs['ModalSales'].hide();
    },
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState('sales', ['sales', 'customer_cash_pending_sales']),
  },
};
</script>
<style scope>
.vs--searchable .vs__dropdown-toggle {
  cursor: text;
  border-radius: 10px;
  height: 35px;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
  width: 100%;
}

h5,
.h5 {
  font-size: 1.25rem;
}
</style>
